import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GroupManagementComponent } from './group-management.component';

const routes: Routes = [
  {
    path: 'group-management',
    component: GroupManagementComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GroupManagementPageRoutingModule {}
